
import { Name } from "../prm/name";
import {RADIO_SINGLE_RANDOM_VALUE, RadioButton} from "../prm/radio-button";

class EmploymentRadioButton extends RadioButton {
  constructor(name) {
    super(name, [
      new Name("employed", "Employed"),
      new Name("selfEmployed", "Self-Employed"),
      new Name("retired", "Retired"),
      new Name("unemployed", "Unemployed"),
      new Name("homemaker", "Homemaker"),
      new Name("student", "Student"),
    ], [], RADIO_SINGLE_RANDOM_VALUE);
  }
}

export { EmploymentRadioButton };
